import { Capacitor } from "@capacitor/core";
import DeviceIDPlugin from "./../../../plugin/DeviceID";
import { Dlog } from "./../../../utils/Dlog";

export function checkView(orientation, configuration) {
  const isDevice = Capacitor.isPluginAvailable("DeviceID");

  console.log("[checkView] configuration", configuration);
  console.log(
    "[checkView] isDevice",
    isDevice,
    configuration.deviceDisplayMode,
    configuration.webDisplayMode
  );

  //logic for overwrite from settings
  if (
    configuration &&
    isDevice &&
    configuration.deviceDisplayMode == "vertical"
  ) {
    console.log("[checkView] device Vertical");
    return "vertical";
  }
  if (
    configuration &&
    isDevice &&
    configuration.deviceDisplayMode == "horizontal"
  ) {
    console.log("[checkView] device horizontal");
    return "horizontal";
  }
  if (
    configuration &&
    !isDevice &&
    configuration.webDisplayMode == "vertical"
  ) {
    console.log("[checkView] web Vertical");
    return "vertical";
  }
  if (
    configuration &&
    !isDevice &&
    configuration.webDisplayMode == "horizontal"
  ) {
    console.log("[checkView] web horizontal");
    return "horizontal";
  }

  if (
    orientation == "landscape-primary" ||
    orientation == "landscape-secondary"
  ) {
    console.log("[checkView] default horizontal");
    return "horizontal";
  }

  console.log("[checkView] default vertical");
  return "vertical";
}
